import RedactionPageGroup from './RedactionPageGroupContainer';

export default RedactionPageGroup;